import React, { useEffect, useState } from 'react'
import { convertReactSelectObjectToValue } from '../../../../../../utils/reporting/config'
import { noSingleQuotesRegex } from '../../../../../../utils/reporting/reportValidations'
import ReportSelect, { BaseSelect } from '../../../../select/ReportSelect'
import { translateArgumentOptions } from '../../../../select/StaticSelectObjects'
import { InputFieldColumn, InputFieldColumnSimple } from '../InputField'

export const FunctionArguments = ({
    index,
    register,
    watch,
    viewOnly,
    control,
    initialValue,
    setValue,
}) => {
    const functionType = convertReactSelectObjectToValue(
        watch(`columns[${index}].function`)
    )

    // const arg0 = convertReactSelectObjectToValue(initialValue)
    const [arg0, setArg0] = useState(
        convertReactSelectObjectToValue(initialValue)
    )

    // useEffect(() => {
    //     setValue(`columns[${index}].functionArgument`, arg0)
    // }, [arg0, setValue])
    // if (functionType === 'CAST') {
    //     return (
    //         <InputFieldColumn
    //             name={`columns[${index}].functionArgument`}
    //             isClearable={false}
    //         >
    //             <ReportSelect
    //                 name={`columns[${index}].functionArgument`}
    //                 control={control}
    //                 rules={{
    //                     required: {
    //                         value: functionType !== null && functionType !== undefined,
    //                         message: 'Required field'
    //                     }
    //                 }}
    //                 options={translateArgumentOptions}
    //                 value={arg0}
    //             />
    //         </InputFieldColumn>
    // )
    // } else if (functionType === 'ISNULL') {
    return (
        <>
            <div
                className={`${
                    functionType &&
                    functionType !== '' &&
                    functionType === 'CAST'
                        ? ``
                        : `collapsedField`
                }`}
            >
                <InputFieldColumn
                    name={`columns[${index}].functionArgument`}
                    isClearable={false}
                >
                    <BaseSelect
                        // name={`columns[${index}].functionArgument`}
                        // control={control}
                        // rules={{
                        //     required: {
                        //         value:
                        //             functionType !== null &&
                        //             functionType !== undefined,
                        //         message: 'Required field',
                        //     },
                        // }}
                        options={translateArgumentOptions}
                        onChange={(selectedValue) => {
                            setValue(
                                `columns[${index}].functionArgument`,
                                selectedValue?.value
                            )
                            setArg0(selectedValue?.value)
                            return selectedValue
                        }}
                        value={
                            translateArgumentOptions.find(
                                (x) => x.value === arg0
                            ) || ''
                        }
                    />
                </InputFieldColumn>
            </div>
            <div
                className={`columns ${
                    functionType &&
                    functionType !== '' &&
                    functionType === 'ISNULL'
                        ? ``
                        : `collapsedField`
                }`}
            >
                <div className="column">
                    <InputFieldColumnSimple
                        name={`columns[${index}].functionArgument`}
                        inputProps={{
                            type: 'text',
                            ref: register({
                                pattern: {
                                    value: noSingleQuotesRegex, // Regex that matches strings without (')
                                    message:
                                        'Single quote characters are not allowed', // Error message
                                },
                                required: {
                                    value:
                                        functionType === 'CAST' &&
                                        functionType !== null &&
                                        functionType !== undefined,
                                    message: 'Required field',
                                },
                            }),
                            defaultValue: arg0,
                            // value: arg0,
                            onChange: (e) => {
                                setArg0(e.target.value)
                                setValue(
                                    `columns[${index}].functionArgument`,
                                    e.target.value
                                )
                            },
                        }}
                    />
                </div>
            </div>
        </>
    )
}
